import React from 'react';
import './Modal.css';

const HelpModal = ({ onClose }) => {
  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Help</h4>
          </div>
          <div className="modal-body">
            <ol>
              <li>Select a study in the patient list to view its images, a new tab will be created for each study.</li>
              <li>Interact with the image using your mouse: 
                <br/>- <b>ww/wl:</b> left click drag
                <br/>- <b>pan:</b> middle click drag
                <br/>- <b>zoom:</b> right click drag
                <br/>- <b>scroll:</b> mouse wheel
              </li>
              <li>Select another series to display by left click the series list on the left</li>
              <li>Select another tool to use with the left mouse button by selecting the tool button</li>
            </ol>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpModal;
